import {
    FactorScore,
    getFactorScore,
} from '@/components/decisionSupport/tables/RecommendationsTable.constants';
import {
    FACTOR_SCORE_BACKGROUNDS,
    StyledRecommendationCell,
} from '@/components/decisionSupport/tables/RecommendationsTable.styled';
import { FC, useMemo } from 'react';

type RecommendationCellProps = {
    value: number | boolean;
    roundedTo?: number;
    isInverse?: boolean;
    range?: [low: number, high: number];
};

export const RecommendationCell: FC<RecommendationCellProps> = (props) => {
    const { range, isInverse, value, roundedTo } = props;

    const score = useMemo(() => {
        if (typeof value === 'boolean') {
            return value ? 100 : 0;
        }
        if (range) {
            const [low, high] = range;
            const difference = high - low;
            if (difference === 0) {
                return 100;
            }
            const distance = isInverse ? high - value : value - low;
            return (distance / difference) * 100;
        }
        return value;
    }, [isInverse, range, value]);

    const roundedValue = useMemo(() => {
        return typeof roundedTo === 'number' ? Math.round(score / roundedTo) * roundedTo : score;
    }, [roundedTo, score]);

    const factorScore: FactorScore = getFactorScore(roundedValue);

    return (
        <StyledRecommendationCell backgroundColor={FACTOR_SCORE_BACKGROUNDS[factorScore]}>
            {roundedValue}
        </StyledRecommendationCell>
    );
};
